// The home route picks the default view: the tenants for the platform
// (ADR-028), live view for everyone else.
const FALLBACK = '/';

/**
 * Returns a safe in-app path for post-login redirects. Anything that could
 * leave the origin (absolute URLs, protocol-relative "//host", backslash
 * tricks) or loop back to the login page falls back to the default view.
 */
export function safeNext(next: string | null): string {
  if (!next?.startsWith('/') || next.startsWith('//') || next.includes('\\')) return FALLBACK;
  try {
    const url = new URL(next, 'http://vms.invalid');
    if (url.origin !== 'http://vms.invalid' || url.pathname.startsWith('/login')) return FALLBACK;
    return url.pathname + url.search + url.hash;
  } catch {
    return FALLBACK;
  }
}
